/**
 *
 * @module callbackUrl
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    string,
    object
} = Check.assert;

/**
 *
 * @class CallbackUrl
 *
 */
export default class CallbackUrl {

    /**
     *
     * @param {Object} options
     * @param {String} [options.cancelUrl=undefined]
     * @param {String} [options.failureUrl=undefined]
     * @param {String} [options.pendingUrl=undefined]
     * @param {String} [options.successUrl=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: 'CallbackUrl(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get cancelUrl() {
                return `${this.ctor} cancelUrl should be a String with length`;
            },
            get failureUrl() {
                return `${this.ctor} failureUrl should be a String with length`;
            },
            get pendingUrl() {
                return `${this.ctor} pendingUrl should be a String with length`;
            },
            successUrl() {
                return `${this.ctor} successUrl should be a String with length`;
            }
        };

        object(options, errorMessage.options, InvalidArgumentException);

        const { cancelUrl, failureUrl, pendingUrl, successUrl } = options;

        if (Check.assigned(cancelUrl)) {
            string(cancelUrl, errorMessage.cancelUrl, InvalidArgumentException);
        }

        if (Check.assigned(failureUrl)) {
            string(failureUrl, errorMessage.failureUrl, InvalidArgumentException);
        }

        if (Check.assigned(pendingUrl)) {
            string(pendingUrl, errorMessage.pendingUrl, InvalidArgumentException);
        }

        if (Check.assigned(successUrl)) {
            string(successUrl, errorMessage.successUrl, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.cancelUrl = cancelUrl;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.failureUrl = failureUrl;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.pendingUrl = pendingUrl;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.successUrl = successUrl;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/callbackUrl.js